export { FullscreenImageModal, type FullscreenImageModalProps } from './FullscreenImageModal';
